<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized && !validkey" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Reset Password</h1>
          <p>
            Please enter your new password.
          </p>
        </div>
      </CardComponent>
    </section>
    <section v-if="initialized && validkey" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Reset Password</h1>
          <p>
            Please enter your new password.
          </p>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-centered">
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Password"
                            rules="required|confirmed:confirmpassword|min:8"
                          >
                            <b-field
                              label="Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="password"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Confirm Password"
                            rules="required"
                            vid="confirmpassword"
                          >
                            <b-field
                              label="Confirm Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="confirmpassword"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-text-centered">
                        <button
                          class="button is-primary btn-align no-lh raised has-margin-bottom-15"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Submit</button
                        ><br />
                        <router-link :to="{ name: 'Login' }"
                          >Back to Login</router-link
                        >
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import AuthApi from '@/api/auth'
export default {
  name: 'ResetPassword',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Reset Password'
  },
  data() {
    return {
      initialized: false,
      loading: false,
      password: '',
      confirmpassword: '',
      validkey: false
    }
  },
  created() {
    AuthApi.verifyPasswordResetKey(this.$route.params.key)
      .then(() => {
        this.initialized = true
        this.validkey = true
      })
      .catch(() => {
        this.$buefy.toast.open({
          message: 'Password reset key invalid.',
          position: 'is-top',
          type: 'is-danger'
        })
        this.initialized = true
        this.validkey = false
      })
  },
  methods: {
    submit() {
      this.loading = true
      AuthApi.resetPassword(this.$route.params.key, this.password)
        .then(() => {
          this.$router.push({ name: 'Login', query: { registered: true } })
          this.$buefy.toast.open({
            message:
              'Your password has been reset, please login with your new password.',
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
        })
        .catch(err => {
          let message = 'Error processing your request.'
          if (err && err.data && err.data.err === 'E_RESET_FAILED') {
            message = 'Error resetting your password.'
          }
          this.$buefy.toast.open({
            message: message,
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
